<template>
  <v-dialog
    :value="value"
    @input="(v) => v || close()"
    max-width="1500px"
  >
    <v-data-table
      disable-pagination
      hide-default-footer
      :headers="h2pTableHeaders"
      :items="h2pfiles"
      :loading="loading"
      loading-text="ローディング..."
      no-data-text="該当データがありません。"
      class="elevation-1 mt-3"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title style="padding-top: 20px;">
            <b>H2Pファイル一覧</b>
            <v-spacer></v-spacer>
            <span style="font-size:17px;">オルソ画像名:{{h2p_data.file_app}}_{{h2p_data.file_name}}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.las_name="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="download"
              text
              @click="download(item.las_path)"
              v-bind="attrs"
              v-on="on"
            >
              <span class="text-truncate" style="max-width: 200px"
                >{{ getTextLasFileName(item) }}
              </span>
            </v-btn>
          </template>
          <h5>{{ getTextLasFileName(item) }}</h5>
        </v-tooltip>
      </template>
      <template v-slot:item.distance="{ item }">
        {{ getDistanceText(item.distance) }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip v-if="item.status === 'H2P_QUEUEING'" color="secondary" small>
          {{ getH2pStatusText(item.status) }}
        </v-chip>
        <v-chip v-if="item.status === 'H2P_PROCESSING'" color="primary" small>
          {{ getH2pStatusText(item.status) }}
        </v-chip>
        <v-chip v-if="item.status === 'H2P_COMPLETED'" color="success" small>
          {{ getH2pStatusText(item.status) }}
        </v-chip>
        <v-chip v-if="item.status === 'H2P_ERROR'" color="error" small>
          {{ getH2pStatusText(item.status) }}
        </v-chip>
      </template>
      <template v-slot:item.created_user="{ item }">
        {{ item.created_user.split("@")[0] }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn
            v-if="item.status == 'H2P_COMPLETED'"
            color="primary"
            text
            @click="download(item.download_path)"
            >ダウンロード</v-btn
          >
          <v-btn
            v-if="
              sharedState.role === 'admin' ||
              sharedState.email === item.created_user
            "
            color="error"
            text
            @click="confirmDeleteH2PFile(item)"
            >削除</v-btn
          >
        </div>
      </template>
    </v-data-table>
  </v-dialog>
</template>
<script>
import {store} from "@/store";
export default {
  name: "H2pShowPvsystLasDialog",
  props: ["value", "h2p_data"],
  data() {
    return {
        // h2p_data: this.h2p_data,
        sharedState: store.state,
        loading: true,
        h2pTableHeaders: [
        {
          text: "種類",
          sortable: false,
          value: "type",
        },
        {
          text: "Lasファイル名",
          sortable: false,
          value: "las_name",
        },
        {
          text: "粗密",
          sortable: false,
          value: "distance",
        },
        {
          text: "作成者",
          sortable: false,
          value: "created_user",
        },
        {
          text: "日付",
          sortable: true,
          value: "created_at",
        },
        {
          text: "状態",
          sortable: false,
          value: "status",
        },
        {
          text: "アクション",
          sortable: false,
          value: "actions",
          align: "center",
        },
      ],
      h2pfiles: [],
    };
  },
  methods: {
    resetData() {
      this.loading = true;
      this.h2pfiles = [];
    },
    getH2pFiles() {
      this.resetData();
      this.axios
        .get("/api/h2p/h2p/" + this.h2p_data.id)
        .then((response) => {
          this.loading = false;
          this.h2pfiles = response.data.h2pfiles;
        });
    },
    getTextLasFileName(item) {
      return item.las_app +'_'+ item.las_id +'_'+ item.las_name;
    },
    getDistanceText(type) {
      if(type != null) {
        const distanceTypes = [
          {text: "密", value: "1"},
          {text: "中間", value: "3"},
          {text: "粗", value: "5"},
          {text: "無し", value: "0"},
        ];
        return distanceTypes.find(x => x.value == type).text;
      }else{
        return "";
      }
      
    },
    getH2pStatusText(type) {
      const h2pStatusTypes = [
        {text: "作成待ち", value: "H2P_QUEUEING"},
        {text: "作成中", value: "H2P_PROCESSING"},
        {text: "作成完了", value: "H2P_COMPLETED"},
        {text: "エラー", value: "H2P_ERROR"},
      ];
      return h2pStatusTypes.find(x => x.value == type).text;
    },
    download(path) {
      this.axios
      .post("/api/h2p/download", { path: path })
      .then((response) => {
        window.location.href = response.data;
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      });
    },
    close() {
      this.$emit("input");
    },
    confirmDeleteH2PFile(item) {
      const confirmDialog = {
        title: '削除確認',
        content:  "データを削除します。よろしいですか。",
        onAgree: () => this.deleteH2PFile(item),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    deleteH2PFile(item) {
      this.axios
      .delete("/api/h2p/"+item.id)
      .then((response) => {
        if(response.status === 204) {
          store.showSuccessDialog("データ削除が完了しました。");
          this.getH2pFiles();
        }
      })
      .catch(() => {
        store.showErrorDialog('エラーが発生しました。再度試してください。');
      });
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.getH2pFiles();
      }
    },
  },
};
</script>
<style scoped>
.download {
  font-weight: normal !important;
  text-transform: none !important;
  color: #1976d2 !important;
}
.v-application .mt-3 {
    margin-top: 0px !important;
}
</style>